const VPS_OPTIMISATION_SPEC = {
    "1": {
        "available": true,
        "details": "",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/php.svg",
            "darkMode": "/assets/images/server-optimisations/php.svg",
            "activeMode": "/assets/images/server-optimisations/php-white.svg"
        },
        "id": "Default",
        "title": "PHP",
        "version": "",
        "tooltip": "Deploy any custom PHP based application or website.",
        "instructions": "",
        "additionalLinks": "",
    },
    "2": {
        "available": true,
        "details": "with Redis",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/wordpress.svg",
            "darkMode": "/assets/images/server-optimisations/wordpress-dm.svg",
            "activeMode": "/assets/images/server-optimisations/wordpress-white.svg"
        },
        "id": "WordPress",
        "title": "WordPress",
        "version": "",
        "tooltip": "Deploy WordPress on a managed server with StackCache® optimisations, Auto Core Updates, WordPress Staging, Management Tools and more.",
        "instructions": "",
        "additionalLinks": "",
    },
    "3": {
        "available": true,
        "details": "with ElasticSearch",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/magento.svg",
            "darkMode": "/assets/images/server-optimisations/magento.svg",
            "activeMode": "/assets/images/server-optimisations/magento-white.svg"
        },
        "id": "Magento",
        "title": "Magento",
        "version": "",
        "tooltip": "Deploy Magento on an optimised cloud server stack with Redis and ElasticSearch pre-installed.",
        "instructions": "",
        "additionalLinks": "",
    },
    "4": {
        "available": true,
        "details": "with Redis & ElasticSearch",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/woocommerce.svg",
            "darkMode": "/assets/images/server-optimisations/woocommerce.svg",
            "activeMode": "/assets/images/server-optimisations/woocommerce-white.svg"
        },
        "id": "WooCommerce",
        "title": "WooCommerce",
        "version": "",
        "tooltip": "Deploy WooCommerce on an optimised cloud server stack with StackCache® optimisations, Auto Core Updates, WordPress Staging, WooCommerce Tools and more.",
        "instructions": "",
        "additionalLinks": "",
    },
    "5": {
        "available": true,
        "details": "with NGINX",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/laravel.svg",
            "darkMode": "/assets/images/server-optimisations/laravel.svg",
            "activeMode": "/assets/images/server-optimisations/laravel-white.svg"
        },
        "id": "Laravel",
        "title": "Laravel",
        "version": "",
        "tooltip": "Deploy Laravel apps on an optimised cloud server stack with easy setup, production ready PHP and full environment control.",
        "instructions": `
            <p>
                Once your Laravel Cloud Server has been provisioned you can create a Hosting
                Package to either create a new Laravel application or to clone an existing
                application in. To create a Hosting Package on your Cloud Server:
            </p>
            <ul>
                <li>Head to <a href="/services/cloud-hosting">Manage Cloud Hosting</a>.</li>
                <li>Select <strong>Hosting Packages</strong> and then <strong>Add Hosting Package</strong>.</li>
                <li>Select your Cloud Server and enter a Domain Name (this can be changed later).</li>
                <li>Now select <strong>Create Hosting Package</strong>.</li>
            </ul>
            <p>
                Your Hosting Package will be provisioned on your Cloud Server ready for your
                Laravel application. You'll be able to manage DNS, apply the Free SSL, add
                email accounts and much more alongside the running of your application.
            </p>
        `,
        "additionalLinks": `
            <a href="https://docs.20i.com/managed-cloud-hosting/how-to-install-and-configure-laravel-with-20icloud" target="_blank">
                How To Host Your Live Laravel Application with 20iCloud
            </a>
        `,
    },
    "7": {
        "available": true,
        "details": "with Redis",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/joomla.svg",
            "darkMode": "/assets/images/server-optimisations/joomla.svg",
            "activeMode": "/assets/images/server-optimisations/joomla-white.svg"
        },
        "id": "Joomla",
        "title": "Joomla!",
        "version": "",
        "tooltip": "Deploy Joomla apps on an optimised cloud server stack with Redis pre-installed.",
        "instructions": "",
        "additionalLinks": "",
    },
    "11": {
        "available": true,
        "details": "",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/dot-net-core.svg",
            "darkMode": "/assets/images/server-optimisations/dot-net-core.svg",
            "activeMode": "/assets/images/server-optimisations/dot-net-core-white.svg"
        },
        "id": "NetCore",
        "title": ".NET Core",
        "version": "",
        "tooltip": "Deploy .NET Core on an optimised cloud server. Once deployed, you can choose between creating an empty project, a .NET Core MVC app or .NET Core API app.",
        "instructions": "",
        "additionalLinks": "",
    },
    "9": {
        "available": true,
        "details": "",
        "icon": {
            "lightMode": "/assets/images/server-optimisations/nodejs.svg",
            "darkMode": "/assets/images/server-optimisations/nodejs.svg",
            "activeMode": "/assets/images/server-optimisations/nodejs-white.svg"
        },
        "id": "NodeJS",
        "title": "NodeJS",
        "version": "",
        "tooltip": "Deploy NodeJS Applications on an optimised Cloud Server stack with Strapi as an optional One-Click CMS install.",
        "instructions": "",
        "additionalLinks": "",
    },
};
